<template>
  <div>
    <template v-for="filter in filtersForCategory" :key="filter.urlParam">
      <component :is="filterTypeToComponent[filter.type]" :filter="filter" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { useProductFilterStore } from '~/stores/productFilter'
import RangeFilter from '~/components/category/product-filters/product-filter-types/RangeFilter.vue'
import CheckboxFilter from '~/components/category/product-filters/product-filter-types/CheckboxFilter.vue'
import ToggleFilter from '~/components/category/product-filters/product-filter-types/ToggleFilter.vue'
import ColorFilter from '~/components/category/product-filters/product-filter-types/ColorFilter.vue'

const filterTypeToComponent = {
  range: RangeFilter,
  multiselect: CheckboxFilter,
  toggle: ToggleFilter,
  color: ColorFilter
}

const productFilterStore = useProductFilterStore()
const route = useRoute()
const categoryPath = route.path || ''
const filtersForCategory = productFilterStore.getProductFiltersByCategoryPath(categoryPath)
</script>
